export default "__VITE_ASSET__DeCU4ZxM__"